"use strict";

jQuery(document).ready(function ($) {
  $('.featured-media__carousel').slick({
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow: '<span class="featured-media__carousel__arrow featured-media__carousel__arrow--prev"></span>',
    nextArrow: '<span class="featured-media__carousel__arrow featured-media__carousel__arrow--next"></span>',
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});